import type { TrendDataPoint } from '../../../types/weatherData';

/**
 * Put a trend series in chronological order for charting.
 *
 * The status endpoint returns every series newest-first
 * (`ORDER BY timestamp DESC LIMIT 24`, weatherDataRouter). The detail-page
 * charts plotted that order straight through, so time ran right-to-left — the
 * left edge of each graph was the latest reading and the right edge was ~24
 * hours earlier.
 *
 * Sorts by timestamp rather than blindly reversing, so the result is correct
 * whichever order the backend happens to send and stays correct if that
 * changes.
 *
 * Reorder BEFORE calling alignGustToWind: that helper matches by timestamp and
 * returns one value per wind point in wind order, so the gust column follows
 * automatically. Reordering afterwards would pair gusts with the wrong hours.
 */
export function toChronological(series: TrendDataPoint[] | undefined): TrendDataPoint[] {
    if (!series || series.length === 0) return [];
    return [...series].sort(
        (a, b) => new Date(a.time).getTime() - new Date(b.time).getTime()
    );
}
